import { render, staticRenderFns } from "./TopBar.vue?vue&type=template&id=c10bbc20"
import script from "./TopBar.vue?vue&type=script&lang=js"
export * from "./TopBar.vue?vue&type=script&lang=js"
import style0 from "./TopBar.vue?vue&type=style&index=0&id=c10bbc20&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports